import React from 'react';
import { useI18n } from 'next-localization';

const Spinner: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="flex items-center justify-center">
      <div
        className="m-auto size-6 animate-spin rounded-full border-2 border-black border-t-[transparent] dark:border-white"
        role="status"
        aria-label={t('content.loading')}
      ></div>
    </div>
  );
};

export default Spinner;
